import { SizeProp } from '@fortawesome/fontawesome-svg-core'
import { faThumbsUp } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { colors } from '../../../common/colors';
import { T, TF } from "react-translator-component";

interface Props {
  iconSize: SizeProp
  liketype: "post" | "comment"
  item: any
}

const Likes: React.FC<Props> = ({
  iconSize,
  liketype,
  item,
}) => {

  return (
    <div
      style={{
        display: liketype === "comment" ? "block" : "flex",
        height: "46px",
        padding: "8px",
      }}
    >
      <div
        style={{
          width: "30px",
          height: "30px",
          fontSize: "24px",
          display: "contents",
        }}
      >
        <FontAwesomeIcon
          size={iconSize}
          icon={faThumbsUp}
          color={colors.farm_gray200 }
        />
      </div>

      {liketype === "comment" ? (
        <div style={styles.favCount}>
          {item?.likes_count || 0}
        </div>
      ) : (
        <div style={styles.likeText}>{TF(T("mng_post_like_count"), item?.likes_count || 0)}</div>
      )}
    </div>
  )
}
const styles = {
  favCount: {
    fontSize: 14,
    paddingLeft: "8px",
  },
  likeText: {
    paddingTop: 6,
    fontSize: 16,
    marginLeft: "8px",
  },
}

export default Likes
